import React from "react"
import Background from "../Background"

const Header = () => {
  return (
    <header id='top'>
      <Background />
    </header>
  )
}

export default Header
